module.exports = __webpack_public_path__ + "static/media/ArrowRight.54f5b676.svg";